import { IOption } from 'modules/national-certificate';

export function useOptionState(checkedId: number | null) {
  const getStateClass = (option: IOption) => {
    const isChecked = option.id === checkedId;
    const isCorrect = option.is_correct;

    if (checkedId !== null && isChecked && !isCorrect) {
      return 'border-red-500 bg-red-50';
    }

    if (isCorrect) {
      return 'border-green-500 bg-green-50';
    }

    return 'border-transparent';
  };

  const getInnerBorderClass = (option: IOption) => {
    const isChecked = option.id === checkedId;
    const isCorrect = option.is_correct;

    return isChecked || isCorrect ? 'border-transparent' : 'border-gray-200';
  };

  return { getStateClass, getInnerBorderClass };
}
